/* 2026-09-18 paid-source continuity (agent).
   The personalization step breaks browser sessions, so click IDs and campaign UTMs must travel with the cart. This
   stores Google/Meta click IDs and non-personal campaign tags in first-party cookies, then writes hidden cart
   attributes that survive into the order. Recipient names, personalization text and gift notes are never read.
   External file on purpose: inline scripts are rewritten by Speedien. */
(function () {
  try {
    var q = new URLSearchParams(location.search);
    var CLICK_KEYS = ['gclid', 'gbraid', 'wbraid', 'fbclid'];
    var UTM_KEYS = ['utm_source', 'utm_medium', 'utm_campaign', 'utm_content', 'utm_term'];
    var MAX_VALUE = 250;

    function getCookie(n) { var m = document.cookie.match('(?:^|; )' + n + '=([^;]*)'); return m ? decodeURIComponent(m[1]) : null; }
    function setCookie(n, value) {
      var d = new Date(); d.setTime(d.getTime() + 90 * 864e5);
      document.cookie = n + '=' + encodeURIComponent(value) + '; expires=' + d.toUTCString() + '; path=/; SameSite=Lax; Secure';
    }

    function clean(value) {
      if (!value) return null;
      return value.replace(/[\u0000-\u001f\u007f]/g, '').slice(0, MAX_VALUE);
    }

    function marketingAllowed() {
      var privacy = window.Shopify && window.Shopify.customerPrivacy;
      return !privacy || typeof privacy.marketingAllowed !== 'function' || privacy.marketingAllowed();
    }

    function collectAndSync() {
      if (!marketingAllowed()) return;

      var attrs = {};
      var hasGclid = !!clean(q.get('gclid'));
      for (var i = 0; i < CLICK_KEYS.length; i++) {
        var key = CLICK_KEYS[i];
        var value = clean(q.get(key));
        // 2026-10-08: iOS ad clicks carry gclid and gbraid together; gclid is the one Google accepts for
        // conversion upload, so gbraid/wbraid are kept only when there is no gclid.
        if (hasGclid && (key === 'gbraid' || key === 'wbraid')) continue;
        var cookie = key === 'fbclid' ? 'ps_fbclid' : 'ps_gclid';
        if (value) setCookie(cookie, key + ':' + value);
      }

      var googleClick = getCookie('ps_gclid');
      var metaClick = getCookie('ps_fbclid');
      if (googleClick) attrs._ads_click = googleClick;
      if (metaClick) attrs._meta_click = metaClick;

      for (var j = 0; j < UTM_KEYS.length; j++) {
        var utmKey = UTM_KEYS[j];
        var utmValue = clean(q.get(utmKey));
        var utmCookie = 'ps_' + utmKey;
        if (utmValue) setCookie(utmCookie, utmValue);
        var storedUtm = getCookie(utmCookie);
        if (storedUtm) attrs['_' + utmKey] = storedUtm;
      }

      if (!Object.keys(attrs).length) return;
      attrs._ads_click_at = new Date().toISOString();
      var signature = JSON.stringify(attrs);
      if (sessionStorage.getItem('ps_paid_source_synced') === signature) return;

      // Hidden cart attributes survive personalization and do not appear to the shopper.
      fetch('/cart/update.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: JSON.stringify({ attributes: attrs })
      }).then(function (r) {
        if (r.ok) sessionStorage.setItem('ps_paid_source_synced', signature);
      }).catch(function () {});
    }

    collectAndSync();
    document.addEventListener('visitorConsentCollected', collectAndSync);
  } catch (e) {}
})();
